<template>
  <div>
    <!-- <h1> Products and Instructional Resources </h1> -->
    <!-- <div class='col s12'>
      <div class='valign-wrapper'>
        <div class='center-align'>
          <p> Filter  </p> <i class='material-icons valign-center'>expand_less</i>
        </div>
      </div>
      
    </div> -->
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div id="begin-sticky" ref="stickyNav"></div>

    <div class="sticky-nav-container">
      <nav class="filter-nav">
        <div class="nav-wrapper valign-wrapper blue">
          <div class="search-bar valign-wrapper">
            <i class="material-icons inline-block">search</i>
            <input
              placeholder="Search"
              v-model.lazy="searchTerm"
              v-debounce="250"
              class="inline-block search-input"
            />
          </div>
          <ul>
            <li tabindex="0" class="dropdown search-dropdown">
              <i class="material-icons inline-block">search</i>
              <transition name="fade">
                <div class="dropdown-menu white">
                  <!-- <div class='input-field col s12'> -->
                  <i class="material-icons">search</i>
                  <input placeholder="Search" v-model="searchTerm" />
                  <!-- </div> -->
                </div>
              </transition>
            </li>
            <li tabindex="0" class="dropdown">
              <span class="dropdown-icon"> Category </span>
              <transition name="fade">
                <div class="dropdown-menu white">
                  <div class="dropdown-menu-body">
                    <h5>Category</h5>
                    <div class="filter-buttons">
                      <button
                        v-for="(category, index) in categories"
                        :key="'category-' + index"
                        :value="category"
                        :class="{ activeClass: isActiveCategory(category) }"
                        class="btn btn-small"
                        tabindex="0"
                        @click="categorySelected($event)"
                      >
                        {{ category }}
                      </button>
                    </div>
                  </div>
                </div>
              </transition>
            </li>
            <li class="dropdown" tabindex="0">
              <span class="dropdown-icon"> Grade Level </span>
              <transition name="fade">
                <div class="dropdown-menu white">
                  <h5>Grade Level</h5>
                  <div class="filter-buttons">
                    <button
                      v-for="(gradeLevel, index) in gradeLevels"
                      :key="'gradeLevel-' + index"
                      :value="gradeLevel"
                      class="btn btn-small"
                      tabindex="0"
                      :class="{ activeClass: isActiveGradeLevel(gradeLevel) }"
                      @click="gradeLevelSelected($event)"
                    >
                      {{ gradeLevel }}
                    </button>
                  </div>
                </div>
              </transition>
            </li>
            <li class="dropdown" tabindex="0">
              <span class="dropdown-icon"> Platform </span>
              <transition name="fade">
                <div class="dropdown-menu white">
                  <h5>Platform</h5>
                  <div class="filter-buttons">
                    <button
                      v-for="(platform, index) in platforms"
                      :key="'platform-' + index"
                      :value="platform"
                      :class="{ activeClass: isActivePlatform(platform) }"
                      class="btn btn-small"
                      tabindex="0"
                      @click="platformSelected($event)"
                    >
                      {{ platform }}
                    </button>
                  </div>
                </div>
              </transition>
            </li>
            <li class="dropdown" tabindex="0">
              <span class="dropdown-icon"> Requirements </span>
              <transition name="fade">
                <div class="dropdown-menu white">
                  <h5>Requirements</h5>
                  <div class="filter-buttons">
                    <button
                      v-for="(requirement, index) in requirements"
                      :key="'requirement-' + index"
                      :value="requirement"
                      :class="{ activeClass: isActiveRequirement(requirement) }"
                      class="btn btn-small"
                      tabindex="0"
                      @click="requirementSelected($event)"
                    >
                      {{ requirement }}
                    </button>
                  </div>
                </div>
              </transition>
            </li>
            <!-- <li class='dropdown' tabindex="0"> 
              <span class='dropdown-icon'> Purchase Type </span>
              <transition name='fade'>
                <div class='dropdown-menu white'>
                  <h5> Purchase Type </h5>
                  <div class='filter-buttons'>
                    <button v-for="(type, index) in purchaseTypes"
                      :key="'purchaseType-' + index"
                      :value="type.value"
                      class='btn btn-small'
                      tabindex="0" 
                    >
                      {{ type.text }}
                    </button> 
                  </div>
                </div>
              </transition>
            </li>  -->
            <li class="reset-filter-button" v-if="hasFilters" tabindex="0">
              <button class="btn red accent-4" @click="resetFilters">
                Reset Filters
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <!-- {{ showCategories }} -->

      <!-- <transition name='fade'>
        <div class='dropdown-menu white' v-if="showCategories" @mouseleave="showCategories = !showCategories">
          <div class='dropdown-menu-body'>
          <h5> Category </h5>
            <div class='filter-buttons'>
              <button v-for="(category,index) in sharepointCategories" 
                :key="'sharepointCategory-' + index" 
                :value="category.Title"
                :class="{activeClass: isActiveCategory(category.Title)}"
                class='btn btn-small'
                @click="categorySelected($event)"  
              > 
                {{ category.Title }} 
              </button>

              <button v-for="(category,index) in edTechCategories"
                :key="'edTechCategory-' + index" 
                :value="category"
                class='btn btn-small'
                :class="{activeClass: isActiveCategory(category)}"
                @click="categorySelected($event)" 
              > 
                {{ category }} 
              </button>
            </div>
          </div>
        </div>
      </transition> -->
    </div>
    <div class="flex-card-container">
      <button
        class="btn red reset-filter-button-mobile"
        v-if="hasFilters"
        @click="resetFilters"
      >
        Reset Filters
      </button>
      <div
        class="flex-card"
        v-for="(item, index) in filteredItems"
        :key="'item-' + index"
      >
        <!-- <Resource v-if="item.type == 'resource'"
          :title="item.data.tool"
          :categories="item.data.category"
          :permissions="item.data.permissions"
          :platforms="item.data.platforms"
          :ages="item.data.age"
        /> -->

        <Resource
          :title="item.tool"
          :description="item.description"
          :categories="item.category"
          :permissions="item.permission"
          :warnings="item.warnings"
          :platforms="item.platforms"
          :ages="item.gradelevel"
          :image="item.imagepublish"
          :button1text="item.button1text"
          :button1url="item.button1url"
          :button2text="item.button2text"
          :button2url="item.button2url"
          :learnMoreLink="item.learnmoreurl"
          :requirements="item.requirements"
        />
      </div>

      <div class="flex-card" v-if="filteredItems.length == 0">
        <div class="col s12">
          <div class="card no-results grey lighten-2">
            <div class="card-title text-center"></div>
            <div class="card-content">
              <!-- <i class='material-icons'>sentiment_very_dissatisfied</i> -->
              <p>
                Didn't find what you were looking for? Submit
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfFpUnthdFehrOElEPoMRuxDo_j1N9N2oevyhNfvXPhgiZ-Hw/viewform"
                >
                  this form
                </a>
                or reach out to your LTI to get it added!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";
import Product from "@/components/Product.vue";
import Resource from "@/components/Resource.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import debounce from "v-debounce";

export default {
  name: "AllListings",
  components: {
    Product,
    Resource,
    LoadingSpinner,
  },
  data: () => {
    return {
      items: [],
      categories: [],
      purchaseTypes: [
        {
          value: "Direct",
          text: "School Direct Purchase",
        },
        {
          value: "Request",
          text: "School Request through Dept. of Technology",
        },
      ],
      gradeLevels: [],
      platforms: [],
      permissions: [],
      requirements: [],
      loading: true,
      error: false,
      errorMessage: "",
      showFilters: true,
      showCategories: false,
      showGradeLevels: false,
      showPlatforms: false,
      showPurchaseTypes: false,
      showSearch: false,
      selectedPurchaseTypes: [],
      selectedGradeLevels: [],
      selectedPlatforms: [],
      selectedCategories: [],
      selectedRequirements: [],
      searchTerm: "",
    };
  },
  methods: {
    appendQueryString() {
      var query = {};
      if (this.searchTerm != "") {
        query.s = this.searchTerm;
      }

      if (this.selectedCategories.length != 0) {
        query.category = this.selectedCategories.toString();
      }

      if (this.selectedGradeLevels.length != 0) {
        query.gradeLevel = this.selectedGradeLevels.toString();
      }

      if (this.selectedPlatforms.length != 0) {
        query.platform = this.selectedPlatforms.toString();
      }

      if (this.selectedRequirements.length != 0) {
        query.requirement = this.selectedRequirements.toString();
      }

      // console.log(this.$route)
      // this.$router.push({path: this.$route.path, query: this.$route.query}).catch(e => {})
      this.$router.push({ query: query });
    },
    categorySelected(event) {
      var selectedValue = event.target.value;

      // console.log(this.selectedCategories.includes(selectedValue))

      if (this.selectedCategories.includes(selectedValue)) {
        this.selectedCategories = this.selectedCategories.filter((elem) => {
          return elem != selectedValue;
        });
      } else {
        this.selectedCategories.push(selectedValue);
      }
      // console.log(this.selectedCategories)
      this.appendQueryString();
    },

    gradeLevelSelected(event) {
      var selectedGradeLevel = event.target.value;

      if (this.selectedGradeLevels.includes(selectedGradeLevel)) {
        this.selectedGradeLevels = this.selectedGradeLevels.filter((elem) => {
          return elem != selectedGradeLevel;
        });
      } else {
        this.selectedGradeLevels.push(selectedGradeLevel);
      }

      // console.log(this.selectedGradeLevels)
      this.appendQueryString();
    },

    platformSelected(event) {
      var selectedPlatform = event.target.value;
      console.log(selectedPlatform);
      if (this.selectedPlatforms.includes(selectedPlatform)) {
        this.selectedPlatforms = this.selectedPlatforms.filter((elem) => {
          return elem != selectedPlatform;
        });
      } else {
        this.selectedPlatforms.push(selectedPlatform);
      }

      // console.log(this.selectedPlatforms)
      this.appendQueryString();
    },

    requirementSelected(event) {
      var selectedRequirement = event.target.value;
      console.log(selectedRequirement);
      if (this.selectedRequirements.includes(selectedRequirement)) {
        this.selectedRequirements = this.selectedRequirements.filter((elem) => {
          return elem != selectedRequirement;
        });
      } else {
        this.selectedRequirements.push(selectedRequirement);
      }

      // console.log(this.selectedPlatforms)
      this.appendQueryString();
    },

    isActiveCategory(val) {
      return this.selectedCategories.find((cat) => {
        return cat.toLowerCase() == val.toLowerCase();
      });
    },

    isActiveGradeLevel(val) {
      return this.selectedGradeLevels.find((gl) => {
        return gl.toLowerCase() == val.toLowerCase();
      });
    },

    isActivePlatform(val) {
      return this.selectedPlatforms.find((platform) => {
        return platform.toLowerCase() == val.toLowerCase();
      });
    },

    isActiveRequirement(val) {
      return this.selectedRequirements.find((requirement) => {
        return requirement.toLowerCase() == val.toLowerCase();
      });
    },

    resetFilters() {
      this.searchTerm = "";
      this.selectedCategories = [];
      this.selectedGradeLevels = [];
      this.selectedPlatforms = [];
      this.selectedPurchaseTypes = [];
      this.selectedPlatforms = [];
      this.selectedRequirements = [];

      window.scrollTo({
        top: document.getElementById("begin-sticky").offsetTop,
        left: 0,
        behavior: "smooth",
      });

      this.appendQueryString();
    },
    presetFilters() {
      // console.log('query string: ')
      // console.log(this.$route.query)
      // console.log(typeof this.$route.query)
      var hasQuery = false;

      if (this.$route.query.s !== undefined) {
        this.searchTerm = this.$route.query.s;
        hasQuery = true;
      }

      if (this.$route.query.category !== undefined) {
        this.selectedCategories = this.$route.query.category.split(",");
        hasQuery = true;
      }

      if (this.$route.query.gradeLevel !== undefined) {
        this.selectedGradeLevels = this.$route.query.gradeLevel.split(",");
        hasQuery = true;
      }

      if (this.$route.query.platform !== undefined) {
        this.selectedPlatforms = this.$route.query.platform.split(",");
        hasQuery = true;
      }

      if (this.$route.query.purchaseType !== undefined) {
        this.selectedPurchaseTypes = this.$route.query.purchaseType.split(",");
        hasQuery = true;
      }

      if (this.$route.query.requirement !== undefined) {
        this.selectedRequirements = this.$route.query.requirement.split(",");
        hasQuery = true;
      }

      if (hasQuery) {
        console.log(hasQuery);
        this.scrollToCards();
      }
      // this.scrollToCards()
    },
    scrollToCards() {
      window.scrollTo({
        top: document.getElementById("begin-sticky").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  computed: {
    filteredItems: function () {
      console.log(this.selectedPlatforms);
      var returnVal = this.items;
      var found = false;
      console.log(this.items[0]);
      // console.log('searchTerm: ' + this.searchTerm)
      if (this.searchTerm != "") {
        // console.log('filtering')
        var re = new RegExp(this.searchTerm, "i");
        returnVal = returnVal.filter((elem) => {
          var searchMatch = elem.tool.search(re) > -1;
          var descriptionMatch = elem.description.search(re) > -1;
          var categoryMatch = false;
          var gradeMatch = false;
          var platformMatch = false;
          var requirementMatch = false;

          elem.category.forEach((element) => {
            if (element.search(re) > -1) {
              categoryMatch = true;
            }
          });

          elem.gradelevel.forEach((element) => {
            if (element.search(re) > -1) {
              gradeMatch = true;
            }
          });

          elem.platforms.forEach((element) => {
            if (element.search(re) > -1) {
              platformMatch = true;
            }
          });

          elem.requirements.forEach((element) => {
            if (element.search(re) > -1) {
              requirementMatch = true;
            }
          });

          return (
            searchMatch ||
            categoryMatch ||
            gradeMatch ||
            platformMatch ||
            descriptionMatch ||
            requirementMatch
          );
        });
      }

      if (this.selectedCategories.length > 0) {
        returnVal = returnVal.filter((elem) => {
          var shouldReturn = false;

          for (var i = 0; i < this.selectedCategories.length; i++) {
            found = elem.category.find((cat) => {
              return (
                cat.toLowerCase() == this.selectedCategories[i].toLowerCase()
              );
            });
            if (found !== undefined) {
              shouldReturn = true;
              break;
            }
          }

          return shouldReturn;
        });
      }

      if (this.selectedGradeLevels.length > 0) {
        returnVal = returnVal.filter((elem) => {
          var shouldReturn = false;

          for (var i = 0; i < this.selectedGradeLevels.length; i++) {
            found = elem.gradelevel.find((gl) => {
              return (
                gl.toLowerCase() == this.selectedGradeLevels[i].toLowerCase()
              );
            });

            if (found !== undefined) {
              shouldReturn = true;
              break;
            }
          }

          return shouldReturn;
        });
      }

      if (this.selectedPlatforms.length > 0) {
        returnVal = returnVal.filter((elem) => {
          var shouldReturn = false;

          for (var i = 0; i < this.selectedPlatforms.length; i++) {
            found = elem.platforms.find((platform) => {
              return (
                platform.toLowerCase() ==
                this.selectedPlatforms[i].toLowerCase()
              );
            });
            if (found !== undefined) {
              shouldReturn = true;
            }
          }

          return shouldReturn;
        });
      }

      if (this.selectedRequirements.length > 0) {
        returnVal = returnVal.filter((elem) => {
          var shouldReturn = false;

          for (var i = 0; i < this.selectedRequirements.length; i++) {
            found = elem.requirements.find((requirement) => {
              return (
                requirement.toLowerCase() ==
                this.selectedRequirements[i].toLowerCase()
              );
            });
            if (found !== undefined) {
              shouldReturn = true;
            }
          }

          return shouldReturn;
        });
      }

      // console.log(returnVal)
      return returnVal;
    },
    hasFilters: function () {
      var returnVal = false;

      returnVal = returnVal || this.searchTerm != "";
      returnVal = returnVal || this.selectedCategories.length != 0;
      returnVal = returnVal || this.selectedGradeLevels.length != 0;
      returnVal = returnVal || this.selectedPlatforms.length != 0;
      returnVal = returnVal || this.selectedPurchaseTypes.length != 0;
      returnVal = returnVal || this.selectedRequirements.length != 0;

      return returnVal;
    },
  },
  directives: {
    debounce,
  },
  mounted() {
    axios
      .get("allProductsAndResources.json")
      .then((response) => {
        console.log(response);
        this.items = response.data.data;
        this.categories = response.data.metadata.categories;
        this.platforms = response.data.metadata.platforms;
        this.permissions = response.data.metadata.permissions;
        this.gradeLevels = response.data.metadata.ages;
        this.requirements = response.data.metadata.requirements;
        console.log("requirements");
        console.log(this.requirements);
        console.log("---------------------------------------");

        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.presetFilters();
      })
      .catch((error) => {
        console.log(error);
        this.error = true;
        this.loading = false;
        this.errorMessage = error;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.filter-buttons > button {
  margin: 5px;
}

/*
input[type="checkbox"]:focus {
  transform: scale(2);
}
*/

#filter-label {
  transition: ease-in-out 0.3s;
}

#filter-label:hover {
  transform: scale(1.01);
}

/*
.filter-buttons > .btn:focus {
  background-color: #26a69a;
}
*/

.activeClass {
  background-color: #2196f3 !important;
}

.no-results {
  /* color: white; */
}

/*
.filter-buttons > button:nth-of-type(1n+10) {display: none;}
*/
</style>
